var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material/Icons black/%\uD560\uC778") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 21.3025846 0 21.3025846 16.9366021 0 16.9366021"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material/Icons-black/%\\uD560\\uC778",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.697415, 0.826502)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1717163,5.85415926 L17.1731739,5.85804616 C17.6177387,6.96678603 18.8819548,7.51046698 19.9945816,7.06444454 L20.2822126,6.94929496 L21.2432501,9.34702995 C21.4123305,9.76875922 21.2077821,10.2468486 20.7855669,10.4164149 L4.66656873,16.877424 C4.24483945,17.0465044 3.76675004,16.841956 3.59766964,16.4197408 L2.63663219,14.0224917 L2.81688745,13.9500981 C3.92902836,13.5040757 4.46785067,12.2374302 4.02328582,11.1286904 L4.02182823,11.1252893 C3.57726339,10.0165495 2.31450488,9.47626957 1.20236396,9.922292 L1.02210871,9.99468562 L0.0596136695,7.59306372 C-0.109466731,7.17133445 0.0931382317,6.68935813 0.51535337,6.51979187 L16.6343516,0.0587827637 C17.0560808,-0.110297637 17.5361137,0.0981376846 17.7051941,0.520352823 L18.6676891,2.92148886 L18.3800581,3.03663844 C17.2674313,3.48266088 16.7271514,4.74541939 17.1717163,5.85415926",
    id: "Fill-1",
    fill: "#F4D864",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.1717163,5.85415926 L17.1731739,5.85804616 C17.6177387,6.96678603 18.8819548,7.51046698 19.9945816,7.06444454 L20.2822126,6.94929496 L21.2432501,9.34702995 C21.4123305,9.76875922 21.2077821,10.2468486 20.7855669,10.4164149 L4.66705459,16.877424 C4.24483945,17.0465044 3.76675004,16.841956 3.59766964,16.4197408 L2.63663219,14.0224917 L2.81688745,13.9500981 C3.92902836,13.5040757 4.46785067,12.2374302 4.02328582,11.1286904 L4.02182823,11.1252893 C3.57726339,10.0165495 2.31450488,9.47626957 1.20236396,9.922292 L1.02210871,9.99468562 L0.0596136695,7.59306372 C-0.109466731,7.17133445 0.0931382317,6.68935813 0.51535337,6.51979187 L16.6343516,0.0587827637 C17.0560808,-0.110297637 17.5361137,0.0981376846 17.7051941,0.520352823 L18.6676891,2.92148886 L18.3800581,3.03663844 C17.2674313,3.48266088 16.7271514,4.74541939 17.1717163,5.85415926",
    id: "Fill-4",
    fill: "#FFE98A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06333935,7.38802944 C9.25039669,7.85445814 9.02349857,8.38453491 8.55706988,8.57159225 C8.09064119,8.75864959 7.56056441,8.53223733 7.37350707,8.06532277 C7.18644973,7.59889408 7.41286199,7.06881731 7.87977655,6.88175997 C8.34620524,6.69470263 8.87628201,6.92160075 9.06333935,7.38802944",
    id: "Fill-6",
    fill: "#F97575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.927559,8.87073823 C14.1146163,9.33716693 13.8877182,9.8672437 13.4212895,10.054301 C12.9548608,10.2413584 12.424784,10.0149461 12.2377267,9.54803156 C12.0506694,9.08160287 12.2770816,8.5515261 12.7439962,8.36446876 C13.2104249,8.17741142 13.7405016,8.40430954 13.927559,8.87073823",
    id: "Fill-8",
    fill: "#F97575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64069062,12.2028854 L9.71114078,12.2213482 C10.0565895,12.3112329 10.4093262,12.1037693 10.4992109,11.7583205 L12.1229658,5.52178023 C12.2128505,5.17633148 12.0058728,4.82310892 11.660424,4.73322422 L11.5899739,4.71476142 C11.2445251,4.62487672 10.8917884,4.83234032 10.8014179,5.17778907 L9.17814883,11.4143294 C9.08826414,11.7597781 9.29524187,12.1130007 9.64069062,12.2028854",
    id: "Fill-10",
    fill: "#F97575"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponPercent);
export default __webpack_public_path__ + "static/media/coupon_percent.974683c3590fa0555c03b9012a19fd60.svg";
export { ForwardRef as ReactComponent };